// import { httpSetToken } from '../utils/request'
import { ldb } from '../utils/validate'
import config from '@/config'

const subscribe = (store) => {
  store.subscribe((mutation) => {
    if (mutation.type === 'setUuid' && !ldb.read('Uuid')) {
      ldb.save('Uuid', mutation.payload)
    }
    if (mutation.type === 'setUserInfo' && !ldb.read(config.USER_KEY)) {
      ldb.save(config.USER_KEY, mutation.payload.userInfo)
    }
  })
}

export default (store) => {
  subscribe(store)
}



// WEBPACK FOOTER //
// ./src/store/pulgin.js